import { Injectable } from '@angular/core';
import { BaseCrudService } from './base-crud.service';
import { Brand } from '../../shared/models';

@Injectable({ providedIn: 'root' })
export class BrandService extends BaseCrudService<Brand> {
  protected readonly endpoint = 'Brand';
}
